import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";

import { requiredValidator } from "../../components/formFields/CommonValidator";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";

import FormImageUpload from "../../components/formFields/FormImageUpload";
// import AppDialog from "../../components/dialog/Dialog";
// import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";

import FormSelectionField from "../../components/formFields/FormSelectionField";

import { STATUSARRAY } from "../../_contstants/common";
import {
  createItineraryFacility,
  getAllItineraryFacility,
  getItineraryFacilityByID,
  itineraryFacilityImageUpload,
  updateItineraryFacility,
} from "./services/itineraryfacility.services";
import { clearItinearyFacilityDetails } from "./itineraryfacilitySlice";
import { closed } from "../../components/drawer/drawerSlice";
import IconButton from "../../components/common/IconButton";
import { RxCross1 } from "react-icons/rx";

const CreateItineraryFacility: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const ItineraryFacilityID = useAppSelector((state) => state.drawer.data);

  const [formKey, setFormKey] = useState(1);
  const loading = useAppSelector((state) => state.itinearyfacility.loading);
  const formLoading = useAppSelector(
    (state) => state.itinearyfacility.formLoading
  );
  const ItineraryFacilityDetail = useAppSelector(
    (state) => state.itinearyfacility.ItinearyFacilityDetail
  );

  useEffect(() => {
    if (ItineraryFacilityID) {
      dispatch(getItineraryFacilityByID(ItineraryFacilityID));
    }
  }, [ItineraryFacilityID]);

  useEffect(() => {
    return () => {
      dispatch(clearItinearyFacilityDetails());
    };
  }, []);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [ItineraryFacilityDetail]);

  const handleSubmit = async (values: any) => {
    const ImageData = new FormData();
    const file =
      values?.FacilityImage && typeof values?.FacilityImage !== "string"
        ? values.FacilityImage[0].getRawFile()
        : "";

    try {
      if (ItineraryFacilityID) {
        const editpayload = {
          ID: ItineraryFacilityID,
          Name: values?.Name ? values?.Name : "",
          IsActive: values?.IsActive === 1,
        };

        const response = await dispatch(updateItineraryFacility(editpayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            values.FacilityImage &&
            typeof values.FacilityImage !== "string"
          ) {
            ImageData.append("FacilityImage", file);
            ImageData.append("ID", values?.ID ? values?.ID : "");

            await dispatch(itineraryFacilityImageUpload(ImageData));
          }
          dispatch(closed());
          dispatch(getAllItineraryFacility());
        }
      } else {
        const insertpayload = {
          Name: values?.Name ? values?.Name : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(createItineraryFacility(insertpayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            values?.FacilityImage &&
            typeof values?.FacilityImage !== "string" &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("FacilityImage", file);
            ImageData.append("ID", response?.payload?.Data?.ID);

            await dispatch(itineraryFacilityImageUpload(ImageData));
          }
          dispatch(closed());
          dispatch(getAllItineraryFacility());
        }
      }
    } catch (error) {
      console.log("error in hanldle submit", error);
      throw error;
    }

    // const isactive = values.IsActive === 1;
    // if (ItineraryFacilityID) {
    //   try {
    //     const ImageData = new FormData();
    //     const file =
    //       values?.FacilityImage && typeof values?.FacilityImage !== "string"
    //         ? values.FacilityImage[0].getRawFile()
    //         : "";
    //     ImageData.append("FacilityImage", file);
    //     ImageData.append("ID", values?.ID ? values?.ID : "");
    //     ImageData.append("IsActive", `${isactive}`);
    //     ImageData.append("Name", values?.Name ? values?.Name : "");
    //     const response = await dispatch(updateItineraryFacility(ImageData));

    //     if (response?.meta?.requestStatus === "fulfilled") {
    //       navigate(-1);
    //     }
    //   } catch (error) {
    //     console.error("Error in handleSubmit:", error);
    //     throw error;
    //   }
    // } else {
    //   try {
    //     const ImageData = new FormData();
    //     const file =
    //       values?.FacilityImage && typeof values?.FacilityImage !== "string"
    //         ? values.FacilityImage[0].getRawFile()
    //         : "";
    //     ImageData.append("FacilityImage", file);
    //     ImageData.append("Name", values?.Name ? values?.Name : "");
    //     ImageData.append("IsActive", `${isactive}`);

    //     const response = await dispatch(createItineraryFacility(ImageData));
    //     if (response?.meta?.requestStatus === "fulfilled") {
    //       navigate(-1);
    //     }
    //   } catch (error) {
    //     console.error("Error in handleSubmit:", error);
    //     throw error;
    //   }
    // }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (loading || formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={ItineraryFacilityDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <GridLayout
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              gap={{ rows: 10 }}
              cols={[{ width: "100%" }]}
            >
              <GridLayoutItem
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "17px 0 8px",
                }}
              >
                <Typography.h4 className="m-0">
                  {ItineraryFacilityID
                    ? "Update Itinerary Facility"
                    : "Add Itinerary Facility"}
                </Typography.h4>
                <IconButton
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                  icon={RxCross1}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  width: "100%",
                }}
              >
                <Field
                  name="Name"
                  label="Name"
                  placeholder="Itinerary Facility"
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  width: "100%",
                }}
              >
                <Field
                  name="IsActive"
                  label="Status"
                  astrike={true}
                  placeholder="i.e. Active"
                  component={FormSelectionField}
                  validator={requiredValidator}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status?.value,
                      label: status?.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  width: "100%",
                }}
              >
                <Field
                  name="FacilityImage"
                  type="file"
                  accept="image/*"
                  label="Facility Image"
                  component={FormImageUpload}
                />
              </GridLayoutItem>

              <GridLayoutItem
                style={{
                  width: "100%",
                  marginTop: 20,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <ButtonWithLoading
                    // tabIndex={12}
                    label={ItineraryFacilityID ? "Update" : "Save"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    // tabIndex={13}
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </div>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateItineraryFacility;
